import React from 'react';
import NotificationService from './components/base/notifications/NotificationService';
import { LanguageService } from './services/LanguageService';
import { withRouter } from 'react-router-dom'
import { Browser } from './services/helpers/Browser';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    //this.state = { hasError: false };
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };

  }

  componentDidCatch(error, errorInfo) {
    if (!Browser.isCrawelerBot(Browser.getUserAgentString())) {
      this.setState({ error, errorInfo })
      if (error["name"] === 'ChunkLoadError' && this.props.type) {
        window.location.href = '/connectionlost.html'
      }
      NotificationService.error({ message: LanguageService?.getTranslation('genericErrorMsg') });
    }

  }

  render() {


    if (this.state.hasError && !Browser.isCrawelerBot(Browser.getUserAgentString())) {
      return <>
        <h1>Something went wrong :( </h1>
        <p>{JSON.stringify(this.state?.error)}</p>
        <p>{JSON.stringify(this.state?.errorInfo)}</p>
      </>
        ;
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);